import "../../../styles/input.css";

export default function Input(props) {
    const {
        name,
        label,
        type,
        value,
        onChange,
        lgHideLabel,
        placeholder,
        disabled,
        error,
        className,
		classLabel,
        classInner,
        ...rest
    } = props;

    return (
        <div className={`input-group flex flex-col self-end ${className}`}>
            {error && (
                <div className={`relative text-status-error`}>
                    <span className={`absolute  ${!label ? "right-1" : "right-0"} top-1 text-xs italic`}>{error}</span>
                </div>
            )}
            {label && 
                <label className={`text-sm font-semibold ${error && "text-status-error"} ${lgHideLabel && "lg:hidden"} ${classLabel}`}>{label}</label>
            }
            <input
                name={name}
                type={type}
                value={value || ""}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                className={`${label && lgHideLabel ? "mt-1 lg:mt-0" : "mt-1"} ${type === "date" ? "date-input" : ""} text-sm border rounded px-4 py-2 focus:outline-none ${error ? "border-status-error": value ? "border-light-2" : "border-light-4"} ${classInner}`}
                {...rest}
            />
            {/* Custom date icon (Do Not Delete!) (re-encoded for css on https://products.aspose.app/svg/encoding/svg-to-css)*/}
            {/*   <svg xmlns="http://www.w3.org/2000/svg" class="h-[24px]" fill="none" viewBox="0 0 84 24" stroke="currentColor" stroke-width="0">
                <text x="0" y="20" fill="currentColor" font-family="system-ui" font-weight="bold" font-size="16pt">Date</text>
                <g transform="translate(60,0)">
                    <path x="40" y="0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </g>
              </svg> */}
        </div>
        
    );
}

/*

Sample Props

label="Input"
type="text"
value={value}
lgHideLabel={true}
onChange={(e) => setValue(e.target.value)}
placeholder="Enter text"
error="Error message"
disabled={false}

 */
